import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardSubtitle, Form, Container, Button, Alert, Modal, UncontrolledTooltip, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { Config, HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import Tasks from "../Dashboard/tasks"
import Select from "react-select"
import { useParams} from 'react-router-dom';
import FMap from 'pages/WQ/Maps/FMaps';


    const CreateWorkOrder = () => {
        const {id} = useParams()
        const [workTypeOptions, setWorkTypeOptions] = useState([])
        const [facilityOptions, setFacilityOptions] = useState([])
        const [equipmentOptions, setEquipmentOptions] = useState([])
        const [isloading, setIsloading] = useState(false);
        const [selectedWorkType, setSelectedWorkType] = useState('')
        const [selectedWorkTypeName, setSelectedWorkTypeName] = useState('')
        const [selectedWorkTypeLevel, setSelectedWorkTypeLevel] = useState('E')
        const [locations, setLocations] = useState([])
        const [trade, setTrades] = useState(['Electrical','Mechanical', 'E-M Electro-Mechanical','Civil','Automotive','Plumbing','General'])
        const [maintenanceTypes, setMaintenanceTypes] = useState(['Planned','Unplanned'])
        const [taskTypes, setTaskTypes] = useState(['Corrective','Breakdown','Service','Installation','Modification','PPM'])
        const [priority, setPriority] = useState(['High','Medium','Low'])
        const [staffRoles, setStaffRoles] = useState(['Team Leader','Electrician','Mechanic','Mate','Casual','Driver','Engineer','Plumber','Team member'])
        const [staffOptions, setStaffOptions] = useState([])

        const [selectedWorkTypeId, setSelectedWorkTypeId] = useState('')
        const [areaName, setAreaName] = useState('')
        const [facilityId, setFacilityId] = useState('')
        const [locationId, setLocationId] = useState('')
        const [equipmentId, setEquipmentId] = useState('')
        const [facilityName, setFacilityName] = useState('')
        const [selectedFacilityName, setSelectedFacilityName] = useState('')
        const [request, setRequest] = useState('')
        const [requestedByName, setRequestedByName] = useState('')
        const [dateTimeRequested, setDateTimeRequested] = useState('')
        const [requestId, setRequestId] = useState('')


        const [team, setTeam] = useState([])
        const [member, setMember] = useState(null)
        const [role, setRole] = useState('')

        const [assignedBy, setAssignedBy] = useState('')
        const [assignedById, setAssignedById] = useState('')
        const [dateTimeAssigned, setDateTimeAssigned] = useState(null)
        const [selectedPriority, setSelectedPriority] = useState('')
        const [selectedTaskType, setSelectedTaskType] = useState('')
        const [selectedMaintenanceType, setSelectedMaintenanceType] = useState('')
        const [jobNo, setJobNo] = useState('')
        const [selectedTrade, setSelectedTrade] = useState('')

        const [modal_line, setmodal_line] = useState(false)
        const [regions, setRegions] = useState([]);
        const [clusters, setClusters] = useState([]);
        const [areas, setAreas] = useState([]);
        const [schemes, setSchemes] = useState([]);
        const [facilities, setFacilities] = useState([]);

        const [title, setTitle] = useState('')

        const [points, setPoints] = useState([])
        const [pipes, setPipes] = useState([])
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        
        const getClusters = (u) =>{
            axios.get(`${url.CLUSTERS}?region?${u}`, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
        }
        const getAreas = (c) =>{
            axios.get(`${url.AREAS}?cluster?${c}`, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
        }
        const getSchemes = (a) =>{
            axios.get(`${url.SCHEME}?area?${a}`, Config).then((r)=>{ setSchemes(r.data) }).catch((e)=>{ console.log(e) })
        }
        const getFacilities = (s) =>{
            axios.get(`${url.FACILITIES}?scheme?${s}`, Config).then((r)=>{ setFacilities(r.data) }).catch((e)=>{ console.log(e) })
        }
        const getLocations = (f) =>{
            axios.get(`${url.FACILITYSTATION}?facility?${f}`, Config).then((r)=>{ setLocations(r.data) }).catch((e)=>{ console.log(e) })
        }
        const getJobTitle = (t,f,e) =>{
            if((t != '') && (f != '')){ 
                const facilityName = facilities.find(obj => obj.id === f).facility
                if(selectedWorkTypeLevel == "E"){
                    if(e != ''){
                        const equipmentName = equipmentOptions.find(obj => obj.id === e).name
                        setTitle(`${t} ${equipmentName} AT ${facilityName}`)
                    } 
                }else{
                    setTitle(`${t} AT ${facilityName}`)
                } 
            }
        }
        const handleTradeChange = (e) =>{
            setSelectedTrade(e)
            setIsloading(true)
            axios.get(`${url.JOBCARD}?${e}`, Config).then((r)=>{
                setJobNo(r.data.card)
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleSaveWO = () =>{
            let data = {}
            if(selectedWorkTypeLevel == 'E'){
                if(equipmentId == ''){
                    toastr.error('Select equipment')
                }else if(facilityId == ''){
                    toastr.error('Select facility')
                }else if(!dateTimeAssigned){
                    toastr.error('Select assigning date and time ')
                }else if(selectedTrade == ''){
                    toastr.error('Select trade')
                }else if(selectedMaintenanceType == ''){
                    toastr.error('Select maintenance type')
                }else if(selectedPriority == ''){
                    toastr.error('Select task priority')
                }else if(team.length < 1){
                    toastr.error('Select maintenance team')
                }else{
                    data = {
                        title: title, 
                        assetType: 'Equipment',
                        eqId : equipmentId,
                        faId : facilityId,
                        requestId: be.decryptId(id),
                        trade: selectedTrade,
                        jobNo:jobNo,
                        type:selectedTaskType,
                        maintenance:selectedMaintenanceType,
                        priority:selectedPriority,
                        assignedOn: dateTimeAssigned[0].toISOString().slice(0, 19).replace('T', ' '),
                        assignedBy: assignedById,
                        team: team,
                        status:'Assigned',
                        createdBy: assignedById,
                        action: 'add'
                     }
                     
                     setIsloading(true)
                     axios.post(url.WORDERS, JSON.stringify(data), Config).then((r)=>{
                        toastr.success(r.data.message)
                        if(r.data.status == 1){
                            history.push(`/WorkOrder-Details/${be.encryptId(r.data.workId)}`)
                        }
                        setIsloading(false)
                     }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                     })
                     
                }
                
            }else if(selectedWorkTypeLevel == 'F'){
                
                if(facilityId == ''){
                    toastr.error('Select facility')
                }else if(!dateTimeAssigned){
                    toastr.error('Select assigning date and time ')
                }else if(selectedTrade == ''){
                    toastr.error('Select trade')
                }else if(selectedMaintenanceType == ''){
                    toastr.error('Select maintenance type')
                }else if(selectedPriority == ''){
                    toastr.error('Select task priority')
                }else if(team.length < 1){
                    toastr.error('Select maintenance team')
                }else{
                    data = {
                        title: title, 
                        assetType: 'Facility',
                        eqId : '',
                        faId : facilityId,
                        requestId: be.decryptId(id),
                        trade: selectedTrade,
                        jobNo:jobNo,
                        type:selectedTaskType,
                        maintenance:selectedMaintenanceType,
                        priority:selectedPriority,
                        assignedOn: dateTimeAssigned[0].toISOString().slice(0, 19).replace('T', ' '),
                        assignedBy: assignedById,
                        team: team,
                        status:'Assigned',
                        createdBy: assignedById,
                        action: 'add'
                     }
                     setIsloading(true)
                     axios.post(url.WORDERS, JSON.stringify(data), Config).then((r)=>{
                        toastr.success(r.data.message)
                        if(r.data.status == 1){
                            history.push(`/WorkOrder-Details/${be.encryptId(r.data.workId)}`)
                        }
                        setIsloading(false)
                     }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                     })
                }
            }
        }
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const addLine = () =>{
            setTeam(team => [...team, { member: member, memberId: member.value, role: role}]);
            tog_line()
            setMember(null)
            setRole('')
        }
        const handleRemoveItem = (k)=>{
            const newItems = [...team];
            newItems.splice(k, 1);
            setTeam(newItems);
        }
        const handleSelectWorkType = (x) =>{
            setSelectedWorkTypeId(x)
            const typeName  = workTypeOptions.find((option)=>option.id === x).type
            const typeLevel = workTypeOptions.find((option)=>option.id === x).level 
            setSelectedWorkTypeName(typeName)
            setSelectedWorkTypeLevel(typeLevel)
            getJobTitle(typeName, facilityId, equipmentId);
        }
        
        const handleSelectedLocation = (e) =>{
            setLocationId(e.target.value)
            setEquipmentOptions([])
            axios.get(`${url.EQUIPMENT}?location?${e.target.value}`, Config).then((r)=>{
                setEquipmentOptions(r.data)
            }).catch((e)=>console.log(e))
        }
        const fetchData = () =>{
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setAssignedById(obj.id)
            setAssignedBy(obj.username)
            setIsloading(true)
            const data = {
                id        : be.decryptId(id),
                startDate : "",
                endDate   : "",
                status    : "",
                region    : "",
                cluster   : "",
                area      : "",
                scheme    : "",
                facility  : ""
              }
            axios.post(`${url.WREQUESTSFILTER}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                setAreaName(r.data[0].area )
                setFacilityName(r.data[0].facility)
                setDateTimeRequested(r.data[0].dateTime)
                setRequestedByName(r.data[0].requestedByName)
                setRequest(r.data[0].details)
                const mData = {filter:r.data[0].facilityId}
                axios.post(url.GEOCOORDINATES, JSON.stringify(mData), Config).then((rr)=>{ setPoints(rr.data); }).catch((re)=>{ console.log(re)})
            }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })
            axios.get(`${url.WTYPES}`, Config).then((r)=>{
                setWorkTypeOptions(r.data)
            }).catch((e)=>{
                console.log(e)
            })
            axios.get(url.FACILITIES, Config).then((r)=>{
                let options = []
                r.data.map((f)=>{
                    options.push({label:f.facility, value:f})
                })
                setFacilityOptions(options)
            }).catch((e)=>{
                console.log(e)
            })
            axios.get(`${url.STAFF}`, Config).then((r)=>{
                let options = []
                r.data.map((s)=>{
                    options.push({label:s.name, value:s.id})
                })
                setStaffOptions(options)
            }).catch((e)=>console.log(e))
            axios.get(url.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
            //axios.get(url.SCHEME, Config).then((r)=>{ setSchemes(r.data); }).catch((e)=>{  console.log(e); });
            //axios.get(url.FACILITIES, Config).then((r)=>{ setFacilities(r.data) }).catch((e)=>{ console.log(e) })
            const mData = {filter:facilityId}
            axios.post(url.GEOCOORDINATES, JSON.stringify(mData), Config).then((r)=>{ setPoints(r.data); }).catch((e)=>{ console.log(e)})
        }
 
        
        useEffect(() => {
          fetchData()
        },[])
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Create work order | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
               
                   
                        <Row>
                        <Col xl={4}>
                       
                              



                             <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Select Team` }</h5>
                                    <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Name</label>
                                            <Select options={staffOptions} value={member} onChange={(data)=>setMember(data)}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Role</label>
                                            <select className="form-select" onChange={(e)=>setRole(e.target.value)} value={role}>
                                                <option value=''></option>
                                                {staffRoles.map((s,k)=>(
                                                    <option key={k} value={s}>{s}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        
                                    </Row>
                                </div>
                                
                                <div className="modal-footer">
                                {isloading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={addLine}>Add...</button> )
                                }</div>
                                </Modal> 

                                
                            
                            <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">LOCATION</h5>
                                                              
                                <FMap points={points} pipes={pipes}/>
                                
                            </Card>
                            
                            </Col>
                            
                            <Col  xl={8}>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">WORK REQUEST DETAILS</h5>
                                <CardBody>
                                <Row>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingIdInput">Area</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={areaName} />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingIdInput">Facility</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={facilityName} />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingIdInput">Requested by</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={requestedByName} />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingIdInput">Date and time requested</label>
                                            <input type="text" className="form-control" disabled={true} defaultValue={dateTimeRequested} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label htmlFor="floatingIdInput">Request Details</label>
                                            <textarea rows={8} className="form-control" disabled={true} defaultValue={request} />
                                        </div>
                                    </Col>
                                </Row>
                                </CardBody>
                            </Card>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Work type and asset</h5>
                                <CardBody>
                                    <Row>
                                        
                                        {(title != '') && (
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Job Title</label>
                                            <input type='text' className='form-control' value={title} onChange={(e)=>setTitle(e.target.value)}/>
                                            </div>
                                        </Col>
                                        )}
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Select work type</label>
                                            <select className='form-select'  value={selectedWorkTypeId} onChange={(e)=>{handleSelectWorkType(e.target.value)}}>
                                                <option></option>
                                                {workTypeOptions.map((t,k)=>(
                                                    <option key={k} value={t.id}>{t.type}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Select Area</label>
                                            <select className='form-select' onChange={(e)=>{getSchemes(e.target.value);}}>
                                                <option></option>
                                                {areas.map((a,k)=>(
                                                    <option key={k} value={a.id}>{a.name}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Select Scheme</label>
                                            <select className='form-select' onChange={(e)=>{getFacilities(e.target.value);}}>
                                                <option></option>
                                                {schemes.map((s,k)=>(
                                                    <option key={k} value={s.id}>{s.scheme}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Select facility</label>
                                            <select className='form-select' onChange={(e)=>{getLocations(e.target.value); setFacilityId(e.target.value); getJobTitle(selectedWorkTypeName, e.target.value, equipmentId)}}>
                                                <option></option>
                                                {facilities.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.facility}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        {(selectedWorkTypeLevel == "E") && (
                                        <>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label htmlFor="floatingnameInput">Select Location</label>
                                            <select className="form-select" onChange={handleSelectedLocation}>
                                                <option value=''></option>
                                                {locations.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.location}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Select Equipment</label>
                                            <select className="form-select" onChange={(e)=>{setEquipmentId(e.target.value); getJobTitle(selectedWorkTypeName, facilityId, e.target.value)}}>
                                                <option value=''></option>
                                                {equipmentOptions.map((e,k)=>(
                                                    <option key={k} value={e.id}>{e.name}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        </>
                                        )}
                                    </Row>
                                   
                                </CardBody>
                            </Card>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Work order details</h5>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Select trade</label>
                                            <select className="form-select" value={selectedTrade} onChange={(e)=>handleTradeChange(e.target.value)}>
                                                <option value=''></option>
                                                {trade.map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Work order number/Job no</label>
                                            <input type='text' className="form-control" defaultValue={jobNo} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Maintenance type</label>
                                            <select className="form-select" value={selectedMaintenanceType} onChange={(e)=>setSelectedMaintenanceType(e.target.value)}>
                                            <option value=''></option>
                                                {maintenanceTypes.map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Task type</label>
                                            <select className="form-select" value={selectedTaskType} onChange={(e)=>setSelectedTaskType(e.target.value)}>
                                                <option value=""></option>
                                                {taskTypes.map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Priority</label>
                                            <select className="form-select" value={selectedPriority} onChange={(e)=>setSelectedPriority(e.target.value)}>
                                            <option value=''></option>
                                                {priority.map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                ))}
                                            </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Date and time assigned</label>
                                            <Flatpickr className="form-control"
                                                onChange={(d)=>{setDateTimeAssigned(d)}}
                                                options={{ altInput: true, enableTime: true, dateFormat: "Y-m-d H:i", disabled: true }}
                                            />
                                            </div>
                                        </Col>
                                        {/* 
                                        <Col md={6}>
                                            <div className="mb-3">
                                            <label>Assigned by</label>
                                            <input type='text' className="form-control" defaultValue={assignedBy} disabled={true}/>
                                            </div>
                                        </Col>
                                        
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Other team members</label>
                                            <Select options={staffOptions} isClearable={true} isSearchable={true} isMulti value={selectedTeam} onChange={(data)=>setSelectedTeam(data)}/>
                                            </div>
                                        </Col>
                                        */}
                                     
                                        
                                    </Row>
                                   
                                    
                                </CardBody>
                            </Card>

                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Team</h5>
                                <CardBody>
                           
                           
                                
                                <div>
                                {(team.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Name</th>
                                                            <th>Role</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {team.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td>{a.member.label}</td>
                                                                <td>{a.role}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                    <div className="d-flex gap-3">
                                                               
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => handleRemoveItem(k)}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                    </></td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No staff assigned</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                            
                     
                                        </div>

                                        <Row className="mb-3 justify-content-center">
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button
                                                    color="success"
                                                    className="btn btn-rounded btn-sm"
                                                    onClick={() => { tog_line(); }}
                                                    >
                                                    Assign team
                                                </Button>
                                            </div>
                                        </Col>
                                        </Row>
                                        <Row className="mb-2 mt-4 justify-content-center">
                                        <Col md={5}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" className="btn btn-rounded" onClick={handleSaveWO}>
                                                    Create work order
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                    
                                     
                                            </CardBody>
                                        </Card>

                            
                                    
                    
                        </Col>
                        
                        </Row>
                      


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default CreateWorkOrder;